export default __webpack_public_path__ + "static/media/reactTodo.8e0f72c0.png";